import ava from "../img/ava.png"

export const user = {
userName: "Pavlo",
userAvatar: <img src={ava} alt="ava"/>
}